import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'center' | 'left';
  tone?: 'dark' | 'light';
  as?: 'h2' | 'h3';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  tone = 'dark',
  as: Tag = 'h2'
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'text-center mx-auto' : 'text-left';
  return <div className={`max-w-2xl ${alignment}`} data-id="element-154" data-mp="bleqfhj4zyxv">
      {eyebrow && <p className={`mb-3 text-xs font-semibold uppercase tracking-[0.22em] ${tone === 'light' ? 'text-wheat' : 'text-clay'}`} data-id="element-155" data-mp="gj6sh4dhx1fs">
          {eyebrow}
        </p>}
      <Tag className={`font-display text-3xl leading-[1.1] sm:text-4xl md:text-[2.75rem] ${tone === 'light' ? 'text-cream' : 'text-forest-dark'}`} data-id="element-156" data-mp="6t52g71l18y8">
        {title}
      </Tag>
      {subtitle && <p className={`mt-4 text-base leading-relaxed sm:text-lg ${tone === 'light' ? 'text-cream/70' : 'text-forest-dark/70'}`} data-id="element-157" data-mp="zbiutr45g2px">
          {subtitle}
        </p>}
    </div>;
}